module.exports = __webpack_public_path__ + "img/remark.ce32ca0f.svg";